import strapiPreviewConfig from 'constants/strapi';
import useMount from 'hooks/useMount';
import usePageLanguage from 'hooks/usePageLanguage';
import usePageSlug from 'hooks/usePageSlug';
import { RouteQueryParams } from 'providers/types';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useGeoZoneStore from 'stores/geoZoneStore';
import useLocalesStore from 'stores/localesStore';
import usePageDataStore from 'stores/pageDataStore';
import isDraft from 'utils/isDraft';

function FetchApiData() {
  const { slug } = usePageSlug();
  const { language } = usePageLanguage();
  const [searchParams] = useSearchParams();
  const [redirectToNotFound, setRedirectToNotFound] = useState<boolean>(false);

  const compare = (a, b) => {
    return a === b;
  };
  const { fetchPageData, isLoggedIn } = usePageDataStore(
    state => ({
      fetchPageData: state.fetchPageData,
      isLoggedIn: state.isLoggedIn,
    }),
    compare,
  );
  const fetchLocales = useLocalesStore(state => state.fetchLocales, compare);
  const fetchGeoZone = useGeoZoneStore(state => state.fetchGeoZone, compare);

  const getDraftRouteParams = useCallback(
    (pageSlug: string) => {
      const routeQueryParams = {};

      if (isDraft({ slug: pageSlug, queryParams: searchParams })) {
        routeQueryParams[strapiPreviewConfig.slugParam] = searchParams.get(
          strapiPreviewConfig.slugParam,
        );
        routeQueryParams[strapiPreviewConfig.secretParam] = searchParams.get(
          strapiPreviewConfig.secretParam,
        );
        routeQueryParams[strapiPreviewConfig.draftRoute] = 'true';
      }
      return routeQueryParams as RouteQueryParams;
    },
    [searchParams],
  );

  useEffect(() => {
    const routeQueryParams = getDraftRouteParams(slug);

    fetchPageData(
      slug || 'home',
      language,
      routeQueryParams,
      isDraft({ slug, queryParams: searchParams }),
    ).catch(() => {
      setRedirectToNotFound(true);
    });
  }, [fetchPageData, getDraftRouteParams, language, searchParams, slug]);

  useEffect(() => {
    if (redirectToNotFound && isLoggedIn !== null) {
      // check refresh token call done for avoid unauthorized bug after redirection
      window.location.href = '/not-found'; // for facing the 404 status here used browser hard reloading
    }
  }, [redirectToNotFound, isLoggedIn, getDraftRouteParams]);

  useMount(() => {
    fetchLocales().catch(console.error);
    fetchGeoZone().catch(console.error);
  });
}

export default FetchApiData;
